var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[(_vm.active)?_c('MapWrapper',{attrs:{"show-bounds":"","any-zoom":"","show-popups":false,"level-headings":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }